"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _mobxReact = require("mobx-react");
var _autobindDecorator = _interopRequireDefault(require("autobind-decorator"));
var _mobx = require("mobx");
var _state = require("@seedlang/state");
var _constants = require("@seedlang/constants");
var _utils = require("@seedlang/utils");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
var ReviewDetailsWrapper = function ReviewDetailsWrapper(Component) {
  var _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5;
  return (0, _mobxReact.observer)(_class = (_class2 = /*#__PURE__*/function (_React$Component) {
    function _class2(props) {
      var _this;
      _classCallCheck(this, _class2);
      _this = _callSuper(this, _class2, [props]);
      _initializerDefineProperty(_this, "showSpinner", _descriptor, _this);
      _initializerDefineProperty(_this, "showChartDetails", _descriptor2, _this);
      _initializerDefineProperty(_this, "forceReviewAfterDue", _descriptor3, _this);
      _initializerDefineProperty(_this, "showUpdatedCardTypeMessage", _descriptor4, _this);
      _initializerDefineProperty(_this, "cardTypeName", _descriptor5, _this);
      _state.AppUI.reviewStore.clearIndexData();
      if (_this.cardId) {
        _this.showSpinner = true;
        _this.loadCard();
      }
      if (_this.card) {
        _this.cardTypeName = _this.card.cardTypeName;
      }
      return _this;
    }
    _inherits(_class2, _React$Component);
    return _createClass(_class2, [{
      key: "card",
      get: function get() {
        if (this.props.card) {
          return this.props.card;
        } else if (this.cardId) {
          return _state.AppUI.cardStore.showData;
        } else {
          return _state.DeckUI.currentCard;
        }
      }
    }, {
      key: "cardId",
      get: function get() {
        var _this$props$route;
        if ((_this$props$route = this.props.route) !== null && _this$props$route !== void 0 && (_this$props$route = _this$props$route.params) !== null && _this$props$route !== void 0 && _this$props$route.cardId) {
          var _this$props$route2;
          return (_this$props$route2 = this.props.route) === null || _this$props$route2 === void 0 || (_this$props$route2 = _this$props$route2.params) === null || _this$props$route2 === void 0 ? void 0 : _this$props$route2.cardId;
        } else if (this.props.card) {
          return this.props.card.id;
        } else if (this.props.cardId) {
          return this.props.cardId;
        } else if (_state.DeckUI.currentCard) {
          return _state.DeckUI.currentCard.id;
        }
      }
    }, {
      key: "showChart",
      get: function get() {
        return !_state.AppUI.loadingReviews && _state.AppUI.reviewStore.hasIndexData && _state.AppUI.reviewStore.indexData.length > 1;
      }
    }, {
      key: "chartWidth",
      get: function get() {
        return _state.DeckUI.layout.innerDeckWidth;
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        _state.AppUI.cardStore.clearShowData();
      }
    }, {
      key: "afterGetCard",
      value: function afterGetCard(resp) {
        _state.AppUI.cardStore.setShowData(resp);
        this.showSpinner = false;
      }
    }, {
      key: "onSnoozeReview",
      value: function onSnoozeReview() {
        if (this.cardId && !this.props.overlayId) {
          _state.DeckUI.cardStore.snooze({
            ids: {
              cardId: this.cardId
            }
          }, this.loadCard);
        } else {
          _state.DeckUI.onSnoozeReview();
        }
      }
    }, {
      key: "onResetReview",
      value: function onResetReview() {
        this.card.onResetReview();
        _state.DeckUI.updateSpacedRepetitionFields(this.card);
        _state.AppUI.cardStore.destroyReviews({
          ids: {
            cardId: this.cardId
          }
        }, this.afterClearReviews);
      }
    }, {
      key: "afterClearReviews",
      value: function afterClearReviews() {
        _state.AppUI.reviewStore.clearIndexData();
      }
    }, {
      key: "loadCard",
      value: function loadCard() {
        _state.AppUI.cardStore.getShow({
          ids: {
            cardId: this.cardId
          }
        }, this.afterGetCard);
        _state.AppUI.loadReviews(this.cardId);
      }
    }, {
      key: "onDeleteReview",
      value: function onDeleteReview() {
        if (this.cardId && !this.props.overlayId) {
          _state.AppUI.cardStore.destroy({
            ids: {
              cardId: this.cardId
            }
          }, this.afterOnDeleteReview);
          _state.AppUI.user.set('reviewCardsCount', _state.AppUI.user.reviewCardsCount - 1);
        } else {
          _state.DeckUI.onDeleteReview();
        }
      }
    }, {
      key: "afterOnDeleteReview",
      value: function afterOnDeleteReview() {
        if (_state.AppUI.layout.isNative) {
          _state.AppUI.cardStore.reloadIndexFiltered({
            queryStrings: {
              my_reviews: true
            }
          });
          this.props.navigation.goBack();
        } else {
          _state.AppUI.routeStore.routeToNamed('reviews.index', {
            page: 1
          });
        }
      }
    }, {
      key: "onRetireReview",
      value: function onRetireReview() {
        if (this.cardId && !this.props.overlayId) {
          _state.AppUI.user.set('retiredCount', _state.AppUI.user.retiredCount + 1);
          _state.AppUI.cardStore.retire({
            ids: {
              cardId: this.cardId
            }
          }, this.loadCard);
        } else {
          _state.DeckUI.onRetireReview();
        }
      }
    }, {
      key: "processScore",
      value: function processScore(score) {
        this.card.processScore(score);
        this.updateSpacedRepetitionFields();
      }
    }, {
      key: "updateSpacedRepetitionFields",
      value: function updateSpacedRepetitionFields() {
        var data = {
          last_score: this.card.lastScore,
          views_count: this.card.viewsCount,
          easiness_factor: this.card.easinessFactor,
          repetition_interval: this.card.repetitionInterval,
          review_after: this.card.reviewAfter ? this.card.reviewAfter.toString : null,
          consecutive_good_scores: this.card.consecutiveGoodScores,
          had_positive_score: this.card.hadPositiveScore
        };
        _state.DeckUI.cardStore.update({
          data: data,
          ids: {
            cardId: this.card.id
          }
        }, this.loadCard);
      }
    }, {
      key: "onChangeCardTypeId",
      value: function onChangeCardTypeId(id) {
        var _this$card, _this$card2;
        (_this$card = this.card) === null || _this$card === void 0 || _this$card.set('cardTypeId', id);
        (_this$card2 = this.card) === null || _this$card2 === void 0 || _this$card2.set('cardTypeName', _constants.Constants.REVIEW_CARD_TYPES.find(function (item) {
          return item.id === id;
        }).name);
        this.cardTypeName = this.card.cardTypeName;
        _state.DeckUI.cardStore.update({
          data: {
            card_type_id: id
          },
          ids: {
            cardId: this.card.id
          }
        }); //, this.loadCard);
        this.showUpdatedCardTypeMessage = true;
      }
    }, {
      key: "onSwitchBackToCustom",
      value: function onSwitchBackToCustom() {
        this.onChangeCardTypeId(_constants.Constants.REVIEW_CARD_TYPES.find(function (item) {
          return item.slug === 'user_submission';
        }).id);
      }
    }, {
      key: "setShowChartDetails",
      value: function setShowChartDetails(showChartDetails) {
        this.showChartDetails = showChartDetails;
      }
    }, {
      key: "hasEditableCardType",
      get: function get() {
        // also in card_type_select_wrapper
        return (0, _utils.isPresent)(this.card) && ['vocab_word_comprehend', 'vocab_word_options', 'vocab_word_translate', 'vocab_sentence_comprehend', 'comprehend', 'translate'].includes(this.card.cardTypeSlug);
      }
    }, {
      key: "render",
      value: function render() {
        return /*#__PURE__*/_react["default"].createElement(Component, _extends({}, this.props, {
          card: this.card,
          cardId: this.cardId,
          showChart: this.showChart,
          onSnoozeReview: this.onSnoozeReview,
          onResetReview: this.onResetReview,
          onDeleteReview: this.onDeleteReview,
          onRetireReview: this.onRetireReview,
          onSwitchBackToCustom: this.onSwitchBackToCustom,
          onChangeCardTypeId: this.onChangeCardTypeId,
          processScore: this.processScore,
          chartWidth: this.chartWidth,
          setShowChartDetails: this.setShowChartDetails,
          showSpinner: this.showSpinner,
          showChartDetails: this.showChartDetails,
          forceReviewAfterDue: this.forceReviewAfterDue,
          showUpdatedCardTypeMessage: this.showUpdatedCardTypeMessage,
          hasEditableCardType: this.hasEditableCardType,
          cardTypeName: this.cardTypeName
        }));
      }
    }]);
  }(_react["default"].Component), _descriptor = _applyDecoratedDescriptor(_class2.prototype, "showSpinner", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "showChartDetails", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "forceReviewAfterDue", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return true;
    }
  }), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "showUpdatedCardTypeMessage", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function initializer() {
      return false;
    }
  }), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "cardTypeName", [_mobx.observable], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class2.prototype, "card", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "card"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "cardId", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "cardId"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "showChart", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "showChart"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "chartWidth", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "chartWidth"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "afterGetCard", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "afterGetCard"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onSnoozeReview", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "onSnoozeReview"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onResetReview", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "onResetReview"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "afterClearReviews", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "afterClearReviews"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "loadCard", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "loadCard"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onDeleteReview", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "onDeleteReview"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "afterOnDeleteReview", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "afterOnDeleteReview"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onRetireReview", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "onRetireReview"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "processScore", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "processScore"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "updateSpacedRepetitionFields", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "updateSpacedRepetitionFields"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onChangeCardTypeId", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "onChangeCardTypeId"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "onSwitchBackToCustom", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "onSwitchBackToCustom"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "setShowChartDetails", [_autobindDecorator["default"]], Object.getOwnPropertyDescriptor(_class2.prototype, "setShowChartDetails"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "hasEditableCardType", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "hasEditableCardType"), _class2.prototype), _class2)) || _class;
};
ReviewDetailsWrapper.displayName = 'ReviewDetailsWrapper';
var _default = exports["default"] = ReviewDetailsWrapper;